import { IPagination } from 'app/types/common';

export interface IOrganisationTagsState {
  readonly organisationTagsById?: any;
  readonly organisationTagIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectOrganisationTagLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddOrganisationTag?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationOrganisationTagIds?: string[];
  readonly currentOrganisationTagId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrganisationTagsSelector
  extends IOrganisationTagsState {
  readonly currentOrganisationTag?: any;
  readonly currentFormOrganisationTag?: any;
  readonly organisationTagsFilteredByOrganisationInSelectFormat?: any;
  readonly organisationTagsByTagAndIdInSelectFormat?: any;
  readonly organisationTagsByIdInSelectFormat?: any;
  readonly organisationTagsFilteredByCompetitionInSelectFormat?: any;
  readonly organisationTagsFilteredByIdInSelectFormat?: any;
}

export enum OrganisationTagsActionTypes {
  GET_ALL_ORGANISATION_TAGS_REQUESTED = 'redux-app/organisation-tags/GET_ALL_ORGANISATION_TAGS_REQUESTED',
  GET_ALL_ORGANISATION_TAGS_PENDING = 'redux-app/organisation-tags/GET_ALL_ORGANISATION_TAGS_PENDING',
  GET_ALL_ORGANISATION_TAGS_SUCCESS = 'redux-app/organisation-tags/GET_ALL_ORGANISATION_TAGS_SUCCESS',
  GET_ALL_ORGANISATION_TAGS_FAIL = 'redux-app/organisation-tags/GET_ALL_ORGANISATION_TAGS_FAIL',
  GET_ORGANISATION_TAG_REQUESTED = 'redux-app/organisation-tags/GET_ORGANISATION_TAG_REQUESTED',
  GET_ORGANISATION_TAG_PENDING = 'redux-app/organisation-tags/GET_ORGANISATION_TAG_PENDING',
  GET_ORGANISATION_TAG_SUCCESS = 'redux-app/organisation-tags/GET_ORGANISATION_TAG_SUCCESS',
  GET_ORGANISATION_TAG_FAIL = 'redux-app/organisation-tags/GET_ORGANISATION_TAG_FAIL',
  UPDATE_ORGANISATION_TAG_REQUESTED = 'redux-app/organisation-tags/UPDATE_ORGANISATION_TAG_REQUESTED',
  UPDATE_ORGANISATION_TAG_PENDING = 'redux-app/organisation-tags/UPDATE_ORGANISATION_TAG_PENDING',
  UPDATE_ORGANISATION_TAG_SUCCESS = 'redux-app/organisation-tags/UPDATE_ORGANISATION_TAG_SUCCESS',
  UPDATE_ORGANISATION_TAG_FAIL = 'redux-app/organisation-tags/UPDATE_ORGANISATION_TAG_FAIL',
  CREATE_ORGANISATION_TAG_REQUESTED = 'redux-app/organisation-tags/CREATE_ORGANISATION_TAG_REQUESTED',
  CREATE_ORGANISATION_TAG_PENDING = 'redux-app/organisation-tags/CREATE_ORGANISATION_TAG_PENDING',
  CREATE_ORGANISATION_TAG_SUCCESS = 'redux-app/organisation-tags/CREATE_ORGANISATION_TAG_SUCCESS',
  CREATE_ORGANISATION_TAG_FAIL = 'redux-app/organisation-tags/CREATE_ORGANISATION_TAG_FAIL',
  DELETE_ORGANISATION_TAG_REQUESTED = 'redux-app/organisation-tags/DELETE_ORGANISATION_TAG_REQUESTED',
  DELETE_ORGANISATION_TAG_PENDING = 'redux-app/organisation-tags/DELETE_ORGANISATION_TAG_PENDING',
  DELETE_ORGANISATION_TAG_SUCCESS = 'redux-app/organisation-tags/DELETE_ORGANISATION_TAG_SUCCESS',
  DELETE_ORGANISATION_TAG_FAIL = 'redux-app/organisation-tags/DELETE_ORGANISATION_TAG_FAIL',
  SELECT_ORGANISATION_TAG_REQUESTED = 'redux-app/organisation-tags/SELECT_ORGANISATION_TAG_REQUESTED',
}

export default null;
